import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import { Form, Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'


import { Formik } from 'formik';
import * as yup from 'yup';


import Dialog from '../../services/Dialogs'


const ModalEditarProveedor = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, proveedor } = params


  const dialog = new Dialog();


  const mensajes_validacion_generico = "Este campo es obligatorio"
  const schema = yup.object().shape({

      proveedor : yup.string().required(mensajes_validacion_generico), 
      razon_social : yup.string().required(mensajes_validacion_generico), 
      telefono : yup.string().required(mensajes_validacion_generico), 
      direccion : yup.string().required(mensajes_validacion_generico), 
      nombre_contacto : yup.string().required(mensajes_validacion_generico), 
      telefono_contacto : yup.string().required(mensajes_validacion_generico), 

  });



const [ envio_server, setSeEnvio ] = useState<boolean>(false)


const enviarFormulario = async (registro:any,event:any) =>{
      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        target: event.target,
        template: ''
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.create( `proveedores/actualizar_datos/${proveedor.uuid}` , { ...registro })

        if(res_){
          toast.success('MENSAJE')
          setTimeout(()=>{
            handleClose()
          },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){
          toast.error(e.response.data)
          // console.log(e.response.data)
        } 
        
      }
     
}




  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Agregar Nuevo Proveedor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {

          }

    <Formik
      validationSchema={schema}
      onSubmit={(values,e)=>{enviarFormulario(values, e)}}
      initialValues={{

          proveedor : proveedor.proveedor,
          razon_social : proveedor.razon_social,
          telefono : proveedor.telefono,
          direccion : proveedor.direccion,
          nombre_contacto : proveedor.nombre_contacto,
          telefono_contacto : proveedor.telefono_contacto,

      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
        <Form id='my-form' noValidate onSubmit={handleSubmit}>




            <Form.Group   className="mb-3" controlId="proveedor">
              <Form.Label>Proveedor</Form.Label>
              <Form.Control
                required
                name="proveedor"
                value={values.proveedor}
                onChange={(e)=>{ setFieldValue('proveedor', (e.target.value || "").toUpperCase() ) }}
                isInvalid={!!errors.proveedor}
              />
              <Form.Control.Feedback type="invalid"> {<>{errors.proveedor}</>} </Form.Control.Feedback>
            </Form.Group>


 

            <Form.Group   className="mb-3" controlId="razon_social">
              <Form.Label>Razón Social</Form.Label>
              <Form.Control
                required
                name="razon_social"
                value={values.razon_social}
                onChange={(e)=>{ setFieldValue('razon_social', (e.target.value || "").toUpperCase() ) }}
                isInvalid={!!errors.razon_social}
              />
              <Form.Control.Feedback type="invalid"> {<>{errors.razon_social}</>} </Form.Control.Feedback>
            </Form.Group>


 

            <Form.Group   className="mb-3" controlId="telefono">
              <Form.Label>Teléfono</Form.Label>
              <Form.Control
                required
                name="telefono"
                value={values.telefono}
                onChange={(e)=>{ setFieldValue('telefono', (e.target.value || "") ) }}
                isInvalid={!!errors.telefono}
              />
              <Form.Control.Feedback type="invalid"> {<>{errors.telefono}</>} </Form.Control.Feedback>
            </Form.Group>


 

            <Form.Group   className="mb-3" controlId="direccion">
              <Form.Label>Dirección</Form.Label>
              <Form.Control
                as="textarea"
                required
                name="direccion"
                value={values.direccion}
                onChange={(e)=>{ setFieldValue('direccion', (e.target.value || "").toUpperCase() ) }}
                isInvalid={!!errors.direccion}
              />
              <Form.Control.Feedback type="invalid"> {<>{errors.direccion}</>} </Form.Control.Feedback>
            </Form.Group>



            <Form.Group   className="mb-3" controlId="nombre_contacto">
              <Form.Label>Contacto con el Proveedor</Form.Label>
              <Form.Control
                required
                name="nombre_contacto"
                value={values.nombre_contacto}
                onChange={(e)=>{ setFieldValue('nombre_contacto', (e.target.value || "").toUpperCase() ) }}
                isInvalid={!!errors.nombre_contacto}
              />
              <Form.Control.Feedback type="invalid"> {<>{errors.nombre_contacto}</>} </Form.Control.Feedback>
            </Form.Group>


 

            <Form.Group   className="mb-3" controlId="telefono_contacto">
              <Form.Label>Teléfono de Contacto</Form.Label>
              <Form.Control
                required
                name="telefono_contacto"
                value={values.telefono_contacto}
                onChange={(e)=>{ setFieldValue('telefono_contacto', (e.target.value || "").toUpperCase() ) }}
                isInvalid={!!errors.telefono_contacto}
              />
              <Form.Control.Feedback type="invalid"> {<>{errors.telefono_contacto}</>} </Form.Control.Feedback>
            </Form.Group>


 


        </Form>
      )}
    </Formik>



        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" form='my-form' type="submit">Guardar <i className="fa fa-save"/></Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}



export default ModalEditarProveedor;